import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const ProtectedRoute = ({ children }) => {
  const { user, loading, checkAuth } = useAuth();
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(
    location.state?.user ? true : null
  );

  useEffect(() => {
    if (location.state?.user) return; // Skip if user passed from AuthCallback
    
    const verify = async () => {
      await checkAuth();
      setIsAuthenticated(!!user);
    };
    
    if (!user && !loading) {
      verify();
    } else if (user) {
      setIsAuthenticated(true);
    }
  }, [user, loading, location.state, checkAuth]);

  if (loading || isAuthenticated === null) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg font-mono">Loading...</div>
      </div>
    );
  }

  if (!user && !loading) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};
